import { render } from "./WizardView.vue?vue&type=template&id=7cb3e797&scoped=true"
import script from "./WizardView.vue?vue&type=script&lang=js"
export * from "./WizardView.vue?vue&type=script&lang=js"

import "./WizardView.vue?vue&type=style&index=0&id=7cb3e797&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cb3e797"]])

export default __exports__